module.exports = __webpack_public_path__ + "img/arrow-right.855a7b7e.svg";